import { Divider } from '@mui/material'
import colors from 'styles/colors'

const SectionDivider = ({ sx = {} }) => (
  <Divider sx={{ width: '100%', color: colors.Grey200, ...sx }} />
)

export default SectionDivider
